import { SagaIterator } from "@redux-saga/core";
import { call, put, takeLatest } from "redux-saga/effects";
import { startSubmit, stopSubmit } from "redux-form";
import { PricingLevelsTypes } from "@/types";

import apiService from "@/App/service";
import { ActionTypes } from "@/App/constants/actionTypes";
import { updatePricingLevelActions } from "@/App/actions";

const showPageAlert = (payload: Record<string, unknown>) => ({
  type: "SHOW_PAGE_ALERT" as const,
  payload,
});


function* updatePricingLevel(payload: PricingLevelsTypes.PricingLevel): Generator {
  return yield apiService({
    url: "/pricing_level/update",
    method: "POST",
    data: payload,
  });
}

export function* updatePricingLevelWorker(
  action: ReturnType<typeof updatePricingLevelActions.updatePricingLevel>,
): SagaIterator {
  const { updatePricingLevelResult } = updatePricingLevelActions;
  const { data, formName } = action.payload;

  try {
    yield put(startSubmit(formName));
    const pricingLevel = yield call(updatePricingLevel, data);
    yield put(updatePricingLevelResult(pricingLevel));
    yield put(showPageAlert({ show: true, type: "success", message: "Pricing level updated successfully." }));

    yield put(stopSubmit(formName));
  } catch (error) {
    yield put(stopSubmit(formName));

    const { data: { message = "" } = {} } = error;
    yield put(showPageAlert({ show: true, type: "error", message: message || error }));
  }
}

export default function* updatePricingLevelWatcher(): SagaIterator {
  yield takeLatest(ActionTypes.UPDATE_PRICING_LEVEL, updatePricingLevelWorker);
}
